import React, { FC, useState, useMemo, useEffect } from 'react';
import { Box, Button } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useIntersect } from '@wix/experts-common';
import { ContentFilter } from '@wix/wix-ui-icons-common';
import { useExploreContext } from '@components/Contexts/ExploreContext';
import { activeFilterCount } from '@utils/filterUtils';
import MobileFilterMenu from '../MobileFilterMenu';
import s from './MobileFilterButton.module.scss';

const Explore: FC = () => {
  const {
    state: {
      selectedServices,
      selectedLanguages,
      selectedPricing,
      selectedLocation,
    },
  } = useExploreContext();
  const { t } = useTranslation();
  const [ref, entry] = useIntersect({}) as any;

  const [showShadow, setShowShadow] = useState(false);
  useEffect(() => {
    if (entry.intersectionRatio < 1) {
      setShowShadow(true);
    } else {
      setShowShadow(false);
    }
  }, [entry]);

  const [openMobileFilter, setOpenMobileFilter] = useState(false);

  const numActiveFilters = useMemo(() => {
    return activeFilterCount({
      selectedServices,
      selectedLanguages,
      selectedPricing,
      selectedLocation,
    });
  }, [selectedServices, selectedLanguages, selectedPricing, selectedLocation]);

  return (
    <>
      <div
        className={showShadow ? `${s.stickyNav} ${s.showShadow}` : s.stickyNav}
        ref={ref}
      >
        <div className={s.buttonContainer}>
          <Box paddingTop="2px" height="54px" verticalAlign="middle">
            <Button
              dataHook="mobile-filter-button"
              priority="secondary"
              prefixIcon={<ContentFilter />}
              onClick={() => setOpenMobileFilter(true)}
            >
              {numActiveFilters > 0
                ? t('mobile-filter-button-cta', { number: numActiveFilters })
                : t('mobile-filter-button-cta-no-number')}
            </Button>
          </Box>
          {openMobileFilter && (
            <MobileFilterMenu setOpenMobileFilter={setOpenMobileFilter} />
          )}
        </div>
      </div>
    </>
  );
};

export default Explore;
